import React, { useState, useEffect } from "react";
import { fetchImage } from "../../api/photo-upload";
import themePropTypes from "../theme-prop-types";

const CareTeamProvider = ({
  provider,
  onViewProfile,
  components: { Button }
}) => {
  const { title, subtitle, gray_subtitle } = provider.cell_data;
  const { name, profile_image } = provider.detail_data;
  const { care_team_relation_id } = provider.url_request_data;
  const [avatar, setAvatar] = useState();

  useEffect(() => {
    if (profile_image) {
      fetchImage(profile_image).then(source => source && setAvatar(source));
    }
  }, []);

  return (
    <div className=''>
      <Button
        className='secondary care-team-provider-button'
        label={
          <div className='content'>
            <div className='img-wrapper'>
              <div className='img-container'>
                {avatar ? (
                  <img
                    src={avatar}
                    data-testid='provider-avatar'
                    alt='provider-avatar'
                  />
                ) : (
                  <div className='img-icon' />
                )}
              </div>
            </div>
            <div className='description-wrapper'>
              <p className='care-provider-title'>{title}</p>
              <p className='care-provider-subtitle'>{subtitle}</p>
              <p className='care-provider-gray-subtitle'>{gray_subtitle}</p>
            </div>
          </div>
        }
        name='care-team-provider'
        onClick={() =>
          onViewProfile({
            name,
            care_team_relation_id
          })
        }
      />
    </div>
  );
};

CareTeamProvider.propTypes = themePropTypes.careTeamProvider;
export default CareTeamProvider;
